import money from '@images/money-header.webp';
import moneyRetina from '@images/money-header@2x.webp';

export const mapping = {
  money: {
    '1x': money,
    '2x': moneyRetina,
  },
};